import type { ReactNode } from 'react'
import { useAccess, type Requirement } from './useAccess'

type CanProps = {
  perm: Requirement
  mode?: 'any' | 'all'
  children: ReactNode
  fallback?: ReactNode
}

/** Нет права — элемента нет. Не disabled, не серый. */
export function Can({ perm, mode = 'any', children, fallback = null }: CanProps) {
  const { can } = useAccess()
  return can(perm, mode) ? children : fallback
}
